import { useMutation } from '@tanstack/react-query';
import { userServiceRepository } from 'services/api/userService/ApiUserServiceRepository';

export const useRequestVerificationMutation = () =>
  useMutation({ mutationFn: (userId: string) => userServiceRepository.requestVerification(userId) });
